<template>
	<div>
		<form novalidate class="md-layout">
			<md-dialog :md-active="$route.name == 'createConsumer'" :md-click-outside-to-close=false :md-close-on-esc=false @md-clicked-outside="close" @keydown.esc="close">
				<md-dialog-title>Create</md-dialog-title>
				<md-dialog-content>
					<div class="md-layout md-gutter">
						<div class="md-layout-item">
							<md-field :class="getValidationClass('name')">
								<label for="name">Name</label>
								<md-input name="name" id="name" v-model="name" :disabled="sending" required/>
								<span class="md-error" v-if="!$v.name.required">Consumer name is required</span>
							</md-field>
						</div>
						<div class="md-layout-item">
							<md-field>
								<label>Programming Types</label>
								<md-select v-model="programmingTypeIds" name="programmingTypeIds" id="programmingTypeIds" multiple>
									<md-option v-for="type in $store.getters.programmingTypes" :key="type.id" :value="type.id">{{type.name}}</md-option>
								</md-select>
							</md-field>
						</div>
					</div>

					<md-progress-bar md-mode="indeterminate" v-if="sending" />
					<md-dialog-actions>
						<md-button class="md-primary" @click="close()">Cancel</md-button>
						<md-button type="submit" class="md-primary" @click="validateConsumer()" :disabled="sending">Create</md-button>
					</md-dialog-actions>
				</md-dialog-content>
			</md-dialog>
		</form>
	</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import {
	required
} from 'vuelidate/lib/validators'

export default {
	name: 'Create',
	mixins: [validationMixin],
	data: () => ({
		name: null,
		programmingTypeIds: null,
		sending: false,
	}),
	validations: {
		name: {
			required
		}
	},
	methods: {
		getValidationClass(fieldName) {
			const field = this.$v[fieldName]

			if (field) {
				return {
					'md-invalid': field.$invalid && field.$dirty
				}
			}
		},
		clearForm() {
			this.$v.$reset()
			this.name = null
		},
		async addConsumer() {
			this.sending = true

			try {
				await this.$apiService.consumer.create({ name: this.name, programmingTypeIds: this.programmingTypeIds })
				this.$snackbar.showMessage('Consumer saved!')
				this.close()
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.sending = false
		},
		async validateConsumer() {
			this.$v.$touch()

			if (!this.$v.$invalid) {
				await this.addConsumer()
			}
		},
		async close() {
			this.sending = false
			this.clearForm()
			try {
				await this.$store.dispatch('loadConsumers', { sortBy: this.sortBy, sortOrder: this.sortOrder })
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.$router.back()
		}
	}
}
</script>
